















import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component({ components: {} })
export default class TitleIcon extends Vue {
  @Prop({ type: String, required: true })
  private className!: string;

  @Emit("emit")
  private emit(event: MouseEvent | TouchEvent) {}
}
